/**
 * „Ankunft“: was gerade angelegt oder geändert wurde, leuchtet an seinem Platz in der Liste kurz auf
 * (CSS-Klasse `ui-ankunft`, App.css) und wird bei Bedarf ins Bild gescrollt.
 *
 * Ablauf: nach dem Speichern `markiereNeu('kunde-12')`, die Zeile trägt `{...ankunft('kunde-12')}`.
 * Die Markierung lebt modulweit, damit sie ein Neuladen der Liste und auch einen Seitenwechsel
 * (anlegen → navigieren) übersteht; nach DAUER_MS verfällt sie von selbst.
 */
const DAUER_MS = 2400;
const markiert = new Map<string, number>();
const gescrollt = new Set<string>();

export const markiereNeu = (schluessel: string) => {
  markiert.set(schluessel, Date.now());
  gescrollt.delete(schluessel);
};

const istFrisch = (schluessel: string): boolean => {
  const zeit = markiert.get(schluessel);
  if (zeit === undefined) return false;
  if (Date.now() - zeit > DAUER_MS) {
    markiert.delete(schluessel);
    return false;
  }
  return true;
};

/**
 * Props für das Element, das aufleuchten soll: `className` (leer, wenn nichts frisch ist) und ein
 * `ref`, das das Element einmalig sanft ins Bild holt. Mit eigener className kombinieren:
 * `className={`… ${a.className}`}`.
 */
export const ankunft = (schluessel: string): { className: string; ref?: (el: HTMLElement | null) => void } => {
  if (!istFrisch(schluessel)) return { className: '' };
  return {
    className: 'ui-ankunft',
    ref: (el: HTMLElement | null) => {
      if (!el || gescrollt.has(schluessel)) return;
      gescrollt.add(schluessel);
      const reduziert = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      // Nach dem Layout, sonst misst der Browser die Liste noch ohne den neuen Eintrag.
      requestAnimationFrame(() => el.scrollIntoView({ block: 'nearest', behavior: reduziert ? 'auto' : 'smooth' }));
    },
  };
};
